import { c as _c } from "react/compiler-runtime";
import { ChangeRoleSubMenu } from "@components/table/members/change-role-sub-menu";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { useChangeWorkspaceRole } from "@hooks/use-change-workspace-role";
import { getAssignableWorkspaceRoles, getDisabledRoles } from "@utils/workspace-role-utils";
/**
 * 3-dot menu item that changes the workspace role of a member or team, with the same roles and
 * checks as the role dropdown (see useChangeWorkspaceRole). When the role needs a Sphere XG seat
 * first, the menu stays open until the dialog asking for the seat is closed.
 */
export function WorkspaceRoleMenuButton(t0) {
  const $ = _c(21);
  const {
    member,
    companyId,
    shouldCheckXgSeat,
    teamName,
    onMenuClose
  } = t0;
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  const t1 = shouldCheckXgSeat ? member : undefined;
  let t2;
  if ($[0] !== companyId || $[1] !== member.identity || $[2] !== member.role || $[3] !== onMenuClose || $[4] !== t1 || $[5] !== teamName) {
    t2 = {
      companyId,
      memberIdentity: member.identity,
      currentRole: member.role,
      member: t1,
      location: "members-role-menu-button",
      teamName,
      onSettled: onMenuClose
    };
    $[0] = companyId;
    $[1] = member.identity;
    $[2] = member.role;
    $[3] = onMenuClose;
    $[4] = t1;
    $[5] = teamName;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    changeRole,
    xgSeatDialog
  } = useChangeWorkspaceRole(t2);
  let t3;
  if ($[7] !== canAssignManagers) {
    t3 = getAssignableWorkspaceRoles("change", canAssignManagers);
    $[7] = canAssignManagers;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = member.role;
  let t5;
  if ($[9] !== t4) {
    t5 = getDisabledRoles(t4);
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== changeRole) {
    t6 = role => void changeRole(role);
    $[11] = changeRole;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== member.role || $[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t7 = <ChangeRoleSubMenu roles={t3} disabledRoles={t5} selectedRole={member.role} onRoleClick={t6} />;
    $[13] = member.role;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7 || $[19] !== xgSeatDialog) {
    t8 = <>{t7}{xgSeatDialog}</>;
    $[18] = t7;
    $[19] = xgSeatDialog;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}